"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserManagedNetworkingTextContent = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const ui_1 = require("../../ui");
const config_1 = require("../../../config");
const use_translation_wrapper_1 = require("../../../hooks/use-translation-wrapper");
const react_i18next_1 = require("react-i18next");
const UserManagedNetworkingTextContent = ({ shouldDisplayLoadBalancersBullet = false, docVersion, }) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(react_core_1.TextContent, null,
        react_1.default.createElement(react_core_1.Text, { component: 'p' },
            react_1.default.createElement(react_i18next_1.Trans, { t: t },
                "ai:Please refer to the",
                ' ',
                react_1.default.createElement(ui_1.ExternalLink, { href: (0, config_1.getOpenShiftNetworkingDocsLink)(docVersion) }, "OpenShift networking documentation"),
                ' ',
                "to configure your cluster's networking, including:")),
        react_1.default.createElement(react_core_1.List, null,
            react_1.default.createElement(react_core_1.ListItem, null, t('ai:DHCP or static IP Addresses')),
            react_1.default.createElement(ui_1.RenderIf, { condition: shouldDisplayLoadBalancersBullet },
                react_1.default.createElement(react_core_1.ListItem, null, t('ai:Load balancers'))),
            react_1.default.createElement(react_core_1.ListItem, null, t('ai:Network ports')),
            react_1.default.createElement(react_core_1.ListItem, null, t('ai:DNS')))));
};
exports.UserManagedNetworkingTextContent = UserManagedNetworkingTextContent;
//# sourceMappingURL=UserManagedNetworkingTextContent.js.map